import { RequestsService } from "@/common/api.service";
import {
  FETCH_REQUEST,
  FETCH_REQUEST_CHAT,
  FETCH_REQUESTS
} from "./actions.type";
import {
  FETCH_REQUEST_END,
  FETCH_REQUEST_START,
  FETCH_REQUEST_CHAT_END,
  FETCH_REQUEST_CHAT_START,
  FETCH_REQUESTS_END,
  FETCH_REQUESTS_START
} from "@/store/mutations.type";

const state = {
  request: {},
  requestChat: {},
  isRequestsLoading: false,
  requests: []
};

const getters = {
  request() {
    return state.request;
  },
  requestChat() {
    return state.requestChat;
  },
  requests() {
    return state.requests;
  },
  isRequestsLoading() {
    return state.isRequestsLoading;
  }
};

const actions = {
  async [FETCH_REQUEST]({ commit }, params) {
    commit(FETCH_REQUEST_START);
    await RequestsService.getRequest(params)
      .then(({ data }) => {
        commit(FETCH_REQUEST_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_REQUEST_CHAT]({ commit }, params) {
    commit(FETCH_REQUEST_START);
    await RequestsService.getListChatMessageRequest(params.id, params)
      .then(({ data }) => {
        commit(FETCH_REQUEST_CHAT_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_REQUESTS]({ commit }, params) {
    commit(FETCH_REQUESTS_START);
    return RequestsService.getListRequests(params)
      .then(({ data }) => {
        commit(FETCH_REQUESTS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_REQUEST_START](state) {
    state.isRequestsLoading = true;
  },
  [FETCH_REQUEST_END](state, request) {
    state.request = request;
    state.isRequestsLoading = false;
  },
  [FETCH_REQUEST_CHAT_START](state) {
    state.isRequestsLoading = true;
  },
  [FETCH_REQUEST_CHAT_END](state, request) {
    state.requestChat = request;
    state.isRequestsLoading = false;
  },
  [FETCH_REQUESTS_START](state) {
    state.isRequestsLoading = true;
  },
  [FETCH_REQUESTS_END](state, requests) {
    state.requests = requests;
    state.isRequestsLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
